import { createSelector } from 'reselect';

import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';
import { getCoworkingOffersSelector } from 'shared/store/coworking/selectors/dump/getCoworkingOffersSelector';
import { coworkingSelectedOfferSelector } from 'shared/store/coworking/selectors/smart/coworkingSelectedOfferSelector';
import { selectedCoworkingTypeSelector } from 'shared/store/coworking/selectors/smart/selectedCoworkingTypeSelector';

export const coworkingSortedOffersSelector = createSelector(
  [selectedCoworkingTypeSelector, getCoworkingOffersSelector, coworkingSelectedOfferSelector],
  (selectedCoworkingType, offers, selectedOffer) => {
    if (selectedCoworkingType === SelectedCoworkingType.SeparateOffice && selectedOffer) {
      return Array.of(selectedOffer).concat(offers.filter(offer => offer.id !== selectedOffer.id));
    }

    return offers;
  },
);
